// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"8066":"46039f34be543aff4138","8697":"bf8ef9aac02126fda431"}[chunkId] + "";
};